import type { serverEnv } from '@theprintbar/server';

const stringWithoutEndingSlash = (string: string) => (string.endsWith('/') ? string.slice(0, -1) : string);
const stringWithoutLeadingSlash = (string: string) => (string.startsWith('/') ? string.slice(1) : string);

export const withWebDomain = (path: string, env: Pick<typeof serverEnv, 'WEB_DOMAIN'>) =>
	`${stringWithoutEndingSlash(env.WEB_DOMAIN)}/${stringWithoutLeadingSlash(path)}`;
export const withPartnersDomain = (path: string, env: typeof serverEnv) =>
	`${stringWithoutEndingSlash(env.PARTNER_DOMAIN)}/${stringWithoutLeadingSlash(path)}`;
export const withAdminDomain = (path: string, env: typeof serverEnv) =>
	`${stringWithoutEndingSlash(env.ADMIN_DOMAIN)}/${stringWithoutLeadingSlash(path)}`;

export const withDomain = (path: string, domain?: string) =>
	domain ? `${stringWithoutEndingSlash(domain)}/${stringWithoutLeadingSlash(path)}` : path;
